import { Panel } from "@xyflow/react";
import { FileText, Info, Maximize2, Minimize2 } from "lucide-react";
import { cn } from "@/lib/utils";
import { useArchViz } from "./ArchVizContext";
import { OverlayToggle } from "./OverlayToggle";

export function CanvasControls() {
  const { state, dispatch } = useArchViz();
  if (!state.architecture) return null;

  return (
    <Panel position="top-right" className="flex items-center gap-1.5">
      <button
        type="button"
        onClick={() => dispatch({ type: "OPEN_DIALOG", dialog: "summary" })}
        className="inline-flex items-center gap-1.5 h-8 px-2.5 rounded-lg border border-border bg-card/90 backdrop-blur shadow-sm text-xs font-medium text-ink hover:bg-surface-tint transition-colors"
        title="Solution summary"
      >
        <FileText className="h-3.5 w-3.5 text-muted-foreground" />
        Summary
      </button>
      <OverlayToggle />
      <CanvasIconButton
        label="Level help & legend"
        onClick={() => dispatch({ type: "OPEN_DIALOG", dialog: "legend" })}
      >
        <Info className="h-4 w-4" />
      </CanvasIconButton>
      <CanvasIconButton
        label={state.fullscreen ? "Exit fullscreen (F)" : "Fullscreen (F)"}
        onClick={() => dispatch({ type: "SET_FULLSCREEN", value: !state.fullscreen })}
      >
        {state.fullscreen ? <Minimize2 className="h-4 w-4" /> : <Maximize2 className="h-4 w-4" />}
      </CanvasIconButton>
    </Panel>
  );
}

function CanvasIconButton({
  label,
  onClick,
  children,
}: {
  label: string;
  onClick: () => void;
  children: React.ReactNode;
}) {
  return (
    <button
      type="button"
      title={label}
      aria-label={label}
      onClick={onClick}
      className={cn(
        "h-8 w-8 rounded-lg border border-border bg-card/90 backdrop-blur shadow-sm",
        "flex items-center justify-center text-muted-foreground hover:bg-surface-tint hover:text-foreground transition-colors",
      )}
    >
      {children}
    </button>
  );
}
